const BASE_URL = 'http://runningrobots.unl.edu:8100';

// export async function getActiveGame() {
//     const requestOptions = {
//         method: 'GET',
//         headers: { 'Content-Type': 'application/json' }
//     }
//     const response = await fetch(`${BASE_URL}/game/id`, requestOptions);
//     const data = await response.json();
//     console.log(data);
//     return data;
// }

export async function createGame() {
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' }
    }
    await fetch(`${BASE_URL}/game/create`, requestOptions)
            .then(response => response.json())
            .then(data => console.log(data));
}

// end game ; set to static game id 0
export async function endGame(gameId: number) {
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' }
    }
    await fetch(`${BASE_URL}/game/end/${gameId}`, requestOptions)
            .then(response => response.json())
            .then(data => console.log(data));
}

export async function endActiveGame() {
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' }
    }
    await fetch(`${BASE_URL}/game/active/end`, requestOptions)
            .then(response => response.json())
            .then(data => console.log(data));
}

export async function removeRobot(robotId: number) {
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' }
    }
    await fetch(`${BASE_URL}/robots/delete?attacker_id=${robotId}`, requestOptions)
            .then(response => response.json())
            .then(data => console.log(data));
}

export async function clearRobot(robotId: number) {
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' }
    }
    await fetch(`${BASE_URL}/robot/clear?attacker_id=${robotId}`, requestOptions)
            .then(response => response.json())
            .then(data => console.log(data));
}
